import React, { forwardRef, useEffect, useRef, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Fade } from "@mui/material";
import { correctedSubCat, findGoodFilters, findModelByFilters, getGoodCategories, getMaterialBySKU, getMaterialExceptions, getThumbnail, materialsOrder, mtlTags, possibleCombo, useLazyBackgroundImage } from "../functions";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import { Popup } from "./Popup";

export default function RightMenu(props) {
    const iframe = props.iframe;
    const { i18n } = useTranslation();
    const [expanded, setExpanded] = useState(0);
    const [mobilePopup, setMobilePopup] = useState(false);
    // const [subCat, setSubCat] = useState({});
    // const [currFilters, setCurrFilters] = useState([]);
    // const [category, setCategory] = useState(props.model.model.category.filter(el => props.model.option.category.includes(el.id)))
    const sortedMaterials = [...props.data.materials].sort((a, b) => {
        return a.name.fr.localeCompare(b.name.fr);
    });

    // Init category
    // useEffect(() => {
    //     if (props.category) {
    //         const zeModel = props.model.model;
    //         // const isDuoton = zeModel.duoton && zeModel.type === "chair";
    //         const category = zeModel.category.filter(el => props.model.option.category.includes(el.id));
    //         console.log(category)
    //         props.setCategory(category)
    //         category?.map((el, i) => {
    //             if (el.materials.length > 1) {
    //                 const id = i + 1;
    //                 // const catID = !isDuoton && (el.materials?.includes("fabric") || el.materials?.includes("leather")) && zeModel.type === "bed" ? el.id : "";
    //                 // console.log(el.materials)
    //                 const currMtlCorrected = Object.keys(props.currMaterials).map(str => str.replace(/\d+/g, ""));
    //                 const cat = el.materials.find(l => currMtlCorrected.includes(l));
    //                 console.log(cat)
    //                 setSubCat(sub => ({ ...sub, [id]: cat }))
    //             }
    //         })
    //     }
    // }, [props.model.option])

    useEffect(() => {
        const filt = props.model?.model?.filters;
        if (filt?.length > 0) {
            // console.log(props.model.option.filters)
            props.setCurrFilters(props.model.option.filters);
        }
    }, [props.model.model])


    useEffect(() => {
        if (props.currFilters?.length > 0) {
            const modelToChange = findModelByFilters(props.currFilters, props.model.model.furnitures);
            if (modelToChange) {
                if (props.tmpInit) {
                    props.setModelCode((el) => ({ ...el, option: modelToChange.SKU }))
                } else {
                    props.settmpInit(true);
                }
            } else {
                props.setCurrFilters(findGoodFilters(props.currFilters, props.model.model.furnitures))
                // console.log(findGoodFilters(props.currFilters, props.model.model.furnitures))
            }
        } else if (props.currFilters?.length === 0) {
            props.settmpInit(true);
        }
    }, [props.currFilters])

    function callParent() {
        // let event = new CustomEvent('closePopup');
        // window.dispatchEvent(event);
        window.parent.postMessage({ closePopup: true }, "*")
    }

    const mtlExceptions = getMaterialExceptions(props.model);
    return (
        <>
            {props.activateX && <span onClick={() => callParent()} className="bigX"></span>}
            <div id="config">
                <div id="configurator">
                    <CustomAccordion
                        id={0}
                        title={props.model?.model?.optTitle?.[i18n.language] || "Option"}
                        type={"format"}
                        opened={expanded}
                        setOpen={setExpanded}
                        formats={props.model.model.furnitures}
                        model={props.model.model}
                        option={props.model.option}
                        setModelCode={props.setModelCode}
                        currFilters={props.currFilters}
                        setCurrFilters={props.setCurrFilters}
                        isSmallScreen={props.isSmallScreen}
                        mobilePopup={mobilePopup}
                        setMobilePopup={setMobilePopup}
                        duotonChoice={props.duotonChoice}
                        setDuotonChoice={props.setDuotonChoice}
                    />
                    {
                        // getGoodCategories(props.model.model.duoton, props.duotonChoice, props.category).map((el, i) => {
                        props.category?.map((el, i) => {
                            const fabMtls = correctedSubCat(el.materials, props.woodException, props.tagToRemove);
                            // console.log(el.materials)
                            const sortedData = fabMtls.sort(
                                (a, b) => materialsOrder.indexOf(a) - materialsOrder.indexOf(b)
                            );
                            return (
                                <CustomAccordion
                                    key={i}
                                    categories={el.materials}
                                    id={el.id + 1}
                                    catID={el.id}
                                    title={el.name[i18n.language].split(" [")[0]}
                                    type={"material"}
                                    opened={expanded}
                                    setOpen={setExpanded}
                                    mtlCat={sortedData}
                                    materials={sortedMaterials}
                                    currMaterials={props.currMaterials}
                                    setCurrMaterials={props.setCurrMaterials}
                                    subCat={props.subCat}
                                    setSubCat={props.setSubCat}
                                    iframe={iframe}
                                    model={props.model.model}
                                    isSmallScreen={props.isSmallScreen}
                                    mobilePopup={mobilePopup}
                                    setMobilePopup={setMobilePopup}
                                    duotonChoice={props.duotonChoice}
                                    parentCat={el}
                                    mtlExceptions={mtlExceptions}
                                />

                            )
                        })
                    }
                    <div id="sizeMention">
                        {t("sizeMention")}
                    </div>
                </div>
            </div>
        </>
    )
}

function CustomAccordion({
    title,
    materials,
    formats,
    opened,
    setOpen,
    mtlCat,
    id,
    type,
    currMaterials,
    setCurrMaterials,
    subCat,
    setSubCat,
    model,
    setModelCode,
    iframe,
    catID,
    currFilters,
    setCurrFilters,
    option,
    isSmallScreen,
    mobilePopup,
    setMobilePopup,
    duotonChoice,
    setDuotonChoice,
    parentCat,
    mtlExceptions,
    categories
}) {
    const { i18n } = useTranslation();
    const expanded = opened === id;
    const handleToggle = () => {
        setOpen(el => el === id ? null : id);
    };
    // let mtType = subCat?.[id] || mtlCat?.[0];
    const isDuoton = duotonChoice === "mono" ? false : model.duoton;
    let numEnd = "";

    if (isDuoton && (mtlCat?.includes("fabric") || mtlCat?.includes("leather"))) {
        numEnd = catID;
    }
    // console.log(parentCat)
    const mtType = parentCat?.materials.find(key => currMaterials[key + numEnd]);
    const mtl = currMaterials?.[mtType + numEnd]?.code;
    const fullMtl = mtl && getMaterialBySKU(materials, mtl);
    // console.log(mtType,catID,numEnd,parentCat?.materials)

    function handleSubCat(val) {
        setSubCat(el => ({ ...el, [id]: val }))
    }



    // 🔹 Version mobile (simple bouton qui ressemble à l’accordion fermé)
    if (isSmallScreen) {
        return (
            <>
                <Popup id={id} title={title} mobilePopup={mobilePopup} setMobilePopup={setMobilePopup} >
                    <MenuContent
                        mtlCat={mtlCat}
                        subCat={subCat}
                        id={id}
                        mtType={mtType}
                        currFilters={currFilters}
                        setCurrFilters={setCurrFilters}
                        formats={formats}
                        option={option}
                        setModelCode={setModelCode}
                        handleSubCat={handleSubCat}
                        materials={materials}
                        setCurrMaterials={setCurrMaterials}
                        mtl={mtl}
                        isDuoton={isDuoton}
                        numEnd={numEnd}
                        model={model}
                        iframe={iframe}
                        type={type}
                        isSmallScreen={isSmallScreen}
                        duotonChoice={duotonChoice}
                        setDuotonChoice={setDuotonChoice}
                        categories={categories}
                    />
                </Popup>
                <div
                    className="customAccordion mobileVersion"
                    onClick={() => setMobilePopup(id)}
                    style={{ display: "block", width: "100%" }}
                >
                    <div className="inner">
                        <h3>{title}</h3>
                        <div className="current">
                            <p className={type !== "material" ? "nocap" : ""}>
                                {type === "material"
                                    ? fullMtl?.name[i18n.language].toLowerCase()
                                    : model.name[i18n.language]}
                            </p>
                            {type === "material" && (
                                <span
                                    style={{ backgroundImage: "url(" + getThumbnail(fullMtl) + ")" }}
                                ></span>
                            )}
                        </div>
                        <div className="plusMinus">
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    // 🔹 Version desktop (Accordion normal)
    return (
        <Accordion className="customAccordion" sx={{ margin: 0, boxShadow: "0", border: "0", borderRadius: 0 }} expanded={expanded} onChange={handleToggle}>
            <AccordionSummary className="stickyTop" sx={{ padding: 0, paddingRight: "43px", paddingLeft: "43px" }}>
                <div className="inner">
                    {/* titre */}
                    <h3 sx={{ flexGrow: 1 }}>{title}</h3>

                    {/* élément choisi */}
                    <div className={`current ${expanded ? "active" : ""}`}>
                        <p className={type !== "material" ? "nocap" : ""}>{type === "material" ? fullMtl?.name[i18n.language].toLowerCase() : model.name[i18n.language]}</p>
                        {type === "material" && <span style={{ backgroundImage: "url(" + getThumbnail(fullMtl) + ")" }}></span>}
                    </div>

                    {/* + / - */}
                    <div className={`plusMinus ${expanded ? "active" : ""}`}>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </AccordionSummary>

            {/* Contenu qui s'affiche quand ouvert */}
            <AccordionDetails className="sideBorder" sx={{ paddingBottom: "15px", paddingTop: "5px", paddingRight: "43px", paddingLeft: "43px" }}>
                <MenuContent
                    subCat={subCat}
                    mtlCat={mtlCat}
                    id={id}
                    mtType={mtType}
                    currFilters={currFilters}
                    setCurrFilters={setCurrFilters}
                    formats={formats}
                    option={option}
                    setModelCode={setModelCode}
                    handleSubCat={handleSubCat}
                    materials={materials}
                    setCurrMaterials={setCurrMaterials}
                    mtl={mtl}
                    isDuoton={isDuoton}
                    numEnd={numEnd}
                    model={model}
                    iframe={iframe}
                    type={type}
                    isSmallScreen={isSmallScreen}
                    duotonChoice={duotonChoice}
                    setDuotonChoice={setDuotonChoice}
                    mtlExceptions={mtlExceptions}
                    categories={categories}
                />
            </AccordionDetails>
        </Accordion >
    );
}

function matchTags(elementTags, mode, multiTags) {
    if (mode !== "pf") {
        // Mode normal : 1 seul tag attendu
        return elementTags.includes(multiTags[0]);
    }

    // Mode performance
    const hasPf = elementTags.includes("pf");
    const hasFa = multiTags.includes("fa") && elementTags.includes("fa");
    const hasFl = multiTags.includes("fl") && elementTags.includes("fl");

    return (
        hasPf &&
        (hasFa || hasFl) &&   // au moins un
        !(hasFa && hasFl)  // mais pas les deux        
    );
}


const MenuContent = ({
    mtlCat,
    subCat,
    id,
    mtType,
    currFilters,
    setCurrFilters,
    formats,
    option,
    setModelCode,
    handleSubCat,
    materials,
    setCurrMaterials,
    mtl,
    isDuoton,
    numEnd,
    model,
    iframe,
    type,
    isSmallScreen,
    duotonChoice,
    setDuotonChoice,
    mtlExceptions,
    categories

}) => {
    // console.log(model,mtlCat)
    const { t, i18n } = useTranslation();
    // const perfoTag = subCat?.[id]?.includes("fabric") || subCat?.[id]?.includes("leather") ? "pf" : "";
    const goodMtType = subCat?.[id] || mtType;
    const tags = mtlTags[goodMtType]?.id;
    const possibleTags = categories?.map(el => mtlTags[el]?.id) ?? [];
    const multiTags = tags === "pf" ? [...possibleTags, tags] : [tags];
    // console.log(tags, multiTags)

    return (
        <>
            {
                mtlCat?.length > 1 &&
                <div className="formatButtons">
                    {mtlCat.map((el, i) => {
                        // console.log(el, subCat)
                        return (
                            <p
                                key={i}
                                onClick={() => handleSubCat(el)}
                                className={subCat[id] === el ? "active" : ""}
                            >
                                {t(el)}
                            </p>
                        )
                    })}
                </div>
            }
            {
                type === "material" ? <Box sx={{
                    gridTemplateColumns: "repeat(auto-fill,minmax(60px,1fr))",
                    display: "grid",
                    textAlign: "center",
                    gap: "20px 50px",

                }}>
                    {
                        materials.filter(el =>
                            // el.type === mtType &&
                            matchTags(el.tags, tags, multiTags) &&
                            // multiTags.every(l => el.tags.includes(l)) &&
                            // el.tags.includes(tags) &&
                            // (tags ? el.tags.includes(tags) : el) &&
                            !el.archived &&
                            !el.name.fr.toLowerCase().includes("noy") &&
                            !mtlExceptions?.includes(el.id)
                        ).map((mt, i) => {
                            const mtlOrientation = model.orientation?.[mt.id] || mt.orientation || "";
                            // console.log(mtlOrientation, mt.name.fr)
                            return (
                                <MtlButton
                                    key={i}
                                    material={mt}
                                    currentMtl={mtl}
                                    setCurrMaterials={setCurrMaterials}
                                    isDuoton={isDuoton}
                                    iframe={iframe}
                                    mtlCat={mtlCat}
                                    catID={numEnd}
                                    modelType={model.type}
                                    isSmallScreen={isSmallScreen}
                                    orientation={mtlOrientation}
                                />
                            )
                        })
                    }
                </Box> :
                    <Box sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "15px",

                    }}>
                        {/* Mode Filtres */}
                        {model.filters?.length > 0 ?
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                {model.duoton &&
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                        <h3>{t("f_upholstery")}</h3>
                                        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                                            <DuotonMenu setDuotonChoice={setDuotonChoice} duotonChoice={duotonChoice} />
                                        </Box>
                                    </Box>
                                }
                                {model.filters.map((el, i) => {
                                    // console.log(model)
                                    const toHide = el.choices.find(l => l.id === currFilters[i])?.name.en === "N/A";
                                    const li = i === model.filters.length - 1;
                                    const compModels = li && model.furnitures.filter(l => {
                                        const tmpArr = [...l.filters];
                                        tmpArr.pop();
                                        // console.log(currFilters)
                                        return tmpArr.every((m, im) => currFilters?.[im] === m);
                                    });
                                    // Petite fonction utilitaire
                                    const matchPrefix = (arr, prefix) =>
                                        prefix.every((val, i) => arr[i] === val);

                                    // 1. Récupère les choix valides (non archivés, et selon li)
                                    const everyFilters = li ? compModels.map(f => [...f.filters].pop()) : [];
                                    const choices = el.choices.filter(l =>
                                        !l.archived && (!li || everyFilters.includes(l.id))
                                    );

                                    // 2. Filtre les meubles selon le préfixe choisi
                                    // console.log(currFilters)
                                    const prevChoice = currFilters.slice(0, i);
                                    const filterVal = model.furnitures
                                        .map(f => f.filters)
                                        .filter(f => matchPrefix(f, prevChoice))
                                        .map(f => f[i]);

                                    // 3. Ne garde que les choix correspondants
                                    const choicesFiltered = choices.filter(c => filterVal.includes(c.id));

                                    return (
                                        <Box key={i} sx={{ display: toHide ? "none" : "flex", flexDirection: "column", gap: 2 }}>
                                            <h3>{el.name?.[i18n.language]}</h3>
                                            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                                                {choicesFiltered.map((ch, ci) => {
                                                    return (
                                                        <RoundedButtonFilters
                                                            key={ci}
                                                            format={ch}
                                                            currFilters={currFilters}
                                                            setCurrFilters={setCurrFilters}
                                                            parentID={el.id}
                                                        />
                                                    )
                                                })}
                                            </Box>
                                        </Box>
                                    )
                                })}
                            </Box>
                            :
                            // Mode duoton
                            model.duoton ?
                                <FabricFilters
                                    model={model}
                                    setModelCode={setModelCode}
                                    duotonChoice={duotonChoice}
                                    setDuotonChoice={setDuotonChoice}
                                    formats={formats}
                                    option={option}
                                />
                                :
                                // Mode Normal
                                formats.filter(el => !el.archived).map((el, i) => {
                                    return (
                                        <RoundedButton
                                            key={i}
                                            format={el}
                                            option={option}
                                            setModelCode={setModelCode}
                                        />
                                    )
                                })}
                    </Box>
            }
        </>
    )
}

// Boutons des matériaux
function MtlButton({ material, currentMtl, setCurrMaterials, iframe, isDuoton, mtlCat, catID, modelType, isSmallScreen, orientation }) {
    const { i18n } = useTranslation();
    const active = material.SKU === currentMtl;
    const title = material.name[i18n.language].toLowerCase()
    const isNew = material.isNew;

    const [bgImage, ref, isFallback] = useLazyBackgroundImage(
        getThumbnail(material),
        "./images/BrokenImg.png"
    );

    function setMaterial(mtl) {
        const goodMtlType = mtl.type + catID;

        // console.log(goodMtlType, orientation)
        iframe.rotateMaterial(goodMtlType, orientation || 0);

        setCurrMaterials((prev) => {
            const updatedCat = mtlCat.filter((cat) => cat + catID !== goodMtlType);
            // console.log(updatedCat)
            if (updatedCat.length > 0) {
                // On supprime l’ancien
                const goodCat = updatedCat[1]?.split("_")[0] || updatedCat[0]?.split("_")[0];
                // console.log(updatedCat)
                const { [goodCat + catID]: _, ...rest } = prev;

                // console.log(mtl.type, { ...rest, [mtl.type]: mtl.SKU })
                // Puis on ajoute le nouveau
                return { ...rest, [goodMtlType]: { code: mtl.SKU, rotation: orientation } };
            }
            // Si updatedCat est vide, on fait le comportement normal (ton code initial)
            return { ...prev, [goodMtlType]: { code: mtl.SKU, rotation: orientation } };
        });

        // if (isDuoton && (mtl.type === "fabric" || mtl.type === "leather")) {
        //     for (let i = 1; i <= 2; i++) {
        //         iframe.setMaterial(`${mtl.type}${i}`, mtl.SKU);
        //     }
        // } else {

        // iframe.setMaterial(goodMtlType, mtl.SKU);
        // if (orientation !== "") {

        // }
        // }
    }

    return (
        <div onClick={() => !active && setMaterial(material)} className={`materialBtn ${isNew ? "new" : ""} ${active ? "active" : ""}`}>
            <HoverMagnifier ref={ref} image={bgImage} isSmallScreen={isSmallScreen} isLoading={isFallback} />
            <p>{title}</p>
        </div>
    )
}

// Boutons des formats
function RoundedButton({ format, option, setModelCode }) {
    const { i18n } = useTranslation();
    const active = option?.SKU === format?.SKU;

    const title = format.name[i18n.language]
    return (
        <div onClick={() => setModelCode((el) => ({ ...el, option: format.SKU }))} className={`roundedlBtn${active ? " active" : ""}`}>
            {title}
        </div>
    )
}

function RoundedButtonFilters({ format, currFilters, setCurrFilters, parentID }) {
    const { i18n } = useTranslation();
    const active = currFilters[parentID] === format.id;

    const title = format.name[i18n.language]
    return (
        <div onClick={() => !active && setCurrFilters(el => {
            const newArr = [...el];   // copie du tableau
            newArr[parentID] = format.id; // remplacement
            return newArr;
        })} className={`roundedlBtn  ${active && "active"}`}>
            {title}
        </div >
    )
}

function DuotonMenu({ setDuotonChoice, duotonChoice }) {
    const { i18n, t } = useTranslation();
    const upholstery = ["mono", "duoA"];
    return (
        upholstery.map((u, ui) => {
            // console.log(u, duotonChoice)
            const active = duotonChoice === u;
            return (
                <div key={ui} onClick={() => setDuotonChoice(u)} className={`roundedlBtn${active ? " active" : ""}`}>
                    {t("u_" + u)}
                </div>
            )
        })
    )
}

function FabricFilters({ model, setModelCode, duotonChoice, setDuotonChoice, formats, option }) {
    const { i18n, t } = useTranslation();
    const filtCat = model?.type === "bed" ? ["upholstery", "size"] : model?.type === "accentPiece" ? ["upholstery", "format"] : model?.type === "barstool" ? ["upholstery", "base"] : ["upholstery", "legs"];
    const upholstery = ["mono", "duoA"];
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
            {filtCat.filter((el, i) => i === 0 || (i === 1 && formats.length > 1)).map((el, i) => {
                const zeI = i === 0 ? "one" : "two";
                const goodName = model.optCat?.[zeI]?.[i18n.language] || t("f_" + el);
                return (
                    <Box key={i} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        <h3>{goodName}</h3>
                        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                            {
                                el === "upholstery" ?
                                    <DuotonMenu setDuotonChoice={setDuotonChoice} duotonChoice={duotonChoice} />
                                    :
                                    formats.filter(f => !f.archived).map((k, v) => {
                                        return (
                                            <RoundedButton
                                                key={v}
                                                format={k}
                                                option={option}
                                                setModelCode={setModelCode}
                                            />
                                        )
                                    })

                            }
                        </Box>
                    </Box>
                )
            })}
        </Box >
    )
}

// Effet de loupe sur matériel
const HoverMagnifier = forwardRef(({ image, size = 56, zoom = 4, offset = { x: 100, y: 100 }, fadeDuration = 200, isSmallScreen, isLoading }, ref) => {
    const [isHovering, setIsHovering] = useState(false);
    const [coords, setCoords] = useState(null);

    const handleMouseEnter = () => setIsHovering(true);
    const handleMouseLeave = () => setIsHovering(false);

    const handleMouseMove = (e) => {
        const magnifierSize = size * zoom;
        const padding = 10; // petit espace pour éviter de coller aux bords

        let newX = e.clientX + offset.x;
        let newY = e.clientY + offset.y;

        // Contraindre dans la largeur de la fenêtre
        if (newX + magnifierSize / 2 > window.innerWidth - padding) {
            newX = window.innerWidth - magnifierSize / 2 - padding;
        }
        if (newX - magnifierSize / 2 < padding) {
            newX = magnifierSize / 2 + padding;
        }

        // Contraindre dans la hauteur de la fenêtre
        if (newY + magnifierSize / 2 > window.innerHeight - padding) {
            newY = window.innerHeight - magnifierSize / 2 - padding;
        }
        if (newY - magnifierSize / 2 < padding) {
            newY = magnifierSize / 2 + padding;
        }

        setCoords({ x: newX, y: newY });
    };

    return (
        <>
            {/* Le span principal */}
            <Box
                ref={ref}
                component="span"
                className={`thumbnail ${isLoading ? "isLoading" : ""}`}
                sx={{
                    display: "inline-block",
                    width: size,
                    height: size,
                    borderRadius: "50%",
                    backgroundImage: `url(${image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    cursor: "pointer",
                }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onMouseMove={handleMouseMove}
            />

            {/* Loupe avec fade in/out */}
            {!isLoading && <Fade in={isHovering && coords !== null} timeout={fadeDuration}>
                <Box
                    sx={{
                        position: "fixed",
                        display: isSmallScreen ? "none" : "block",
                        left: coords?.x,
                        top: coords?.y,
                        width: size * zoom,
                        height: size * zoom,
                        borderRadius: "50%",
                        pointerEvents: "none",
                        backgroundImage: `url(${image})`,
                        backgroundSize: `${150}%`,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                        transform: "translate(-50%, -50%)",
                        zIndex: 500
                    }}
                />
            </Fade>}
        </>
    );
});